module.exports = __webpack_public_path__ + "static/media/about2.0dea6c63.jpg";